import {FC} from 'react'
import {Link} from 'react-router-dom'

const JobAdd: FC = () => {
  return (
    <Link
      to='/jobs/add'
      className='btn btn-primary d-flex align-items-center justify-content-center'
      style={{width: '35px', height: '35px', borderRadius: '50%', padding: 0}}
      data-bs-toggle='tooltip'
      data-bs-placement='top'
      title='Add Job'
    >
      <i className='bi bi-plus fs-3 p-0'></i>
    </Link>
  )
}

export default JobAdd
